export const DEFAULT_HITS_PER_PAGE = 20;
export const DEFAULT_TEXT = {
  BUTTONS: {
    SHOW_MORE: 'Show more',
    SHOW_LESS: 'Show less',
    RESET: 'Reset search',
    SEARCH: 'Search',
    REFINE: 'Refine {{count}} result(s)'
  },
  EMPTY_STATE: {
    TITLE: 'No results where found.',
    BODY: 'Try a different search term or try adjusting the filters.'
  },
  SEARCH_BAR: {
    PLACEHOLDER: 'Search term'
  },
  ACTIVE_FACETS: {
    EMPTY_STATE: 'No active filters selected'
  },
  STATS: {
    TOTAL_RESULTS: 'Results: {{count}}'
  },
  SORT_BY: {
    PLACEHOLDER: 'Sort by'
  },
  AUTOSUGGEST: {
    ASSISTIVE_HINT: 'When autosuggest results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.'
  }
};

/**
 * Replace a param in a default text string with a passed value
 * @param {string} text
 * @param {string} paramKey
 * @param {string} paramValue
 * @returns string
 */
export const getDefaultText = (text, paramKey, paramValue) => {
  const textToReplace = text || '';
  const paramToReplace = paramKey || '';
  const paramValueToPlace = paramValue || '';
  return textToReplace.replace("{{".concat(paramToReplace, "}}"), paramValueToPlace);
};
export default {
  DEFAULT_TEXT,
  getDefaultText
};
export const DEFAULT_REQUEST_OPTIONS = {
  hooks: {
    beforeSearch: requests => {
      const requestsWithOptions = requests;
      if (requestsWithOptions[0]) {
        // ElasticSearch track_total_hits will actually show the total hits,
        // instead of a maximum of 10.000.
        requestsWithOptions[0].body.track_total_hits = true;
      }
      return new Promise(resolve => {
        resolve(requests);
      });
    }
  }
};

// We currently only use menu, refinementList and toggle as
// possible search filter types. Change this in the future
// if we add more types.
export const SEARCH_FILTER_TYPES = ['menu', 'refinementList', 'toggle'];